import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';

@Injectable({ providedIn: 'root' })
export class SalaryGridService {
  url = ConfigService.toApiUrl('salary-grids/');
  constructor(private http: HttpClient) {}

  getAll() { return this.http.get<any>(`${this.url}`, ConfigService.addAction('list')); }
  store(r: any) { return this.http.post<any>(`${this.url}`, r, ConfigService.addAction('add')); }
  update(id: any, r: any) { r['_method'] = 'patch'; return this.http.post<any>(`${this.url}${id}`, r, ConfigService.addAction('edit')); }
  delete(id: any) { return this.http.delete<any>(`${this.url}${id}`, ConfigService.addAction('delete')); }
}
